import { useContext } from 'react';
import { SubscriptionPlanProductType } from '../graphql/api-platform-graphql';
import { ReactSubscriptionsContext } from './subscription-plan-provider.react-component';
function useSubscriptionPlan(productType) {
  const subscriptionPlansContext = useContext(ReactSubscriptionsContext);
  return subscriptionPlansContext[productType];
}
export const useConsumerSubscriptionPlan = () => {
  return useSubscriptionPlan(SubscriptionPlanProductType.Consumersubscription);
};
export const useConsumerSubscriptionValuePlan = () => {
  return useSubscriptionPlan(SubscriptionPlanProductType.ConsumersubscriptionValuePlan);
};
export const useConsumerSubscriptionGwGPlan = () => {
  return useSubscriptionPlan(SubscriptionPlanProductType.GrowWithGoogle);
};
export const useConsumerSubscriptionGwGPlusPersonalPlan = () => {
  return useSubscriptionPlan(SubscriptionPlanProductType.ConsumersubscriptionPlusGrowWithGoogle);
};
export const useTeamSubscriptionPlan = () => {
  return useSubscriptionPlan(SubscriptionPlanProductType.Team);
};
export const useActiveSubscriptions = () => {
  const subscriptionPlansContext = useContext(ReactSubscriptionsContext);
  return Object.values(subscriptionPlansContext).filter(plan => !!(plan && !plan.isLoading && !!plan.isSubscriberToSpecificPlan));
};
//# sourceMappingURL=use-subscription-context.js.map